export const TICKET_STATUS_IDS = {
  atamaBekleyen: "c94f0b39-47cf-43ea-9c06-a886943c1030",
  beklemede:     "fb939613-6149-4799-9837-a6ae823b8983",
  tamamlanan:    "b69b62f7-3800-458a-bcc0-e1a72bc7a9b8",
  acik:          "1ab0e936-3557-4c2a-8d8c-dc1900bf464b",
  kapali:        "c11e154e-6839-40be-9c9d-8209693034f4",
};

export const TICKET_STATUS_OPTIONS: { id: string; label: string }[] = [
  { id: TICKET_STATUS_IDS.acik,          label: "Açık" },
  { id: TICKET_STATUS_IDS.atamaBekleyen, label: "Atama Bekleyen" },
  { id: TICKET_STATUS_IDS.beklemede,     label: "Beklemede" },
  { id: TICKET_STATUS_IDS.tamamlanan,    label: "Tamamlanan" },
  { id: TICKET_STATUS_IDS.kapali,        label: "Kapalı Ticketler" },
];
